module.exports = __webpack_public_path__ + "static/icon-form.efbc35fa.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/icon-form.png
// module id = 982
// module chunks = 2